import './assets/assets/css/theme.css';import './assets/assets/css/main.css';var u = Object.defineProperty;
var i = (s, e, t) => e in s ? u(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var a = (s, e, t) => i(s, typeof e != "symbol" ? e + "" : e, t);
import { jsx as n } from "react/jsx-runtime";
import { createContext as r, useMemo as d, createElement as h, useContext as p } from "react";
/* empty css                */
/* empty css                 */
import l from "./i18n.js";
import { useTheme as x } from "./themes/useTheme.js";
const f = r();
class E {
  constructor() {
    a(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
}
function N(s) {
  let {
    i18n: e,
    defaultNS: t,
    children: m
  } = s;
  const c = d(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return h(f.Provider, {
    value: c
  }, m);
}
const T = l, o = r({
  theme: { currentTheme: "ThemeLightGreen", updateTheme: () => {
  } }
}), R = ({
  children: s
}) => {
  const [e, t] = x();
  return /* @__PURE__ */ n(N, { i18n: T, children: /* @__PURE__ */ n(
    o.Provider,
    {
      value: { theme: { currentTheme: e, updateTheme: t } },
      children: s
    }
  ) });
}, v = () => p(o), U = () => v().theme;
export {
  o as F,
  f as I,
  E as R,
  R as a,
  U as b,
  T as i,
  v as u
};
